import { render, staticRenderFns } from "./company-footer.vue?vue&type=template&id=310ad78c&"
import script from "./company-footer.vue?vue&type=script&lang=ts&"
export * from "./company-footer.vue?vue&type=script&lang=ts&"
import style0 from "./company-footer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports